import { TemplatePreview } from '@indigohive/templates-gallery-components'
import { GetCollectionTemplateBySlugResult } from '@indigohive/cogfy-types/endpoints/getCollectionTemplateBySlug'
import ReactMarkdown from 'react-markdown'
import { Provider } from '@indigohive/cogfy-providers'
import { ColoredTag } from '../ColoredTag'

type TemplateDescriptionProps = {
  template: GetCollectionTemplateBySlugResult
  providers?: {
    name: Provider["name"]
    image: string
  }[]
}

export function TemplateDescription (props: TemplateDescriptionProps) {
  const { template, providers } = props

  return (
    <div className="bg-base-100 rounded-t-3xl p-12 md:pb-60 container mx-auto">
      <div className="pb-8">
        <TemplatePreview collection={template.definition.collection} />
      </div>
      <div className="grid grid-cols-12 gap-3 grid-rows-1">
        <div className="flex flex-col gap-8 pb-8 md:pb-0 col-span-12 md:col-span-4">
          {(providers && providers.length > 0) &&
            <div className="flex flex-col gap-4">
              <span className="manrope-bold text-lg">Connections</span>
              <div className="flex flex-wrap gap-4">
                {providers.map(provider => (
                  <div key={provider.name} className="inline-flex items-center gap-2">
                    <img
                      className="rounded size-10 border border-neutral/40"
                      src={provider.image}
                      alt={provider.name}
                    />
                    <span className="manrope-bold text-base">{provider.name}</span>
                  </div>
                ))}
              </div>
            </div>
          }
          <div className="flex flex-col gap-4">
            <span className="manrope-bold text-lg">Contact email</span>
            <a
              href="mailto:indigohive@indigohive.com.br"
              className="manrope-regular text-base hover:underline"
            >
              indigohive@indigohive.com.br
            </a>
          </div>
          <div className="flex gap-2 flex-wrap">
            {template.tags.map(tag => (
              <ColoredTag key={tag.id} label={tag.name} />
            ))}
          </div>
        </div>
        <ReactMarkdown
          className="manrope-regular text-lg col-span-12 md:col-span-8"
          components={{
            h2: value => <h2 className="manrope-bold text-xl">{value.children}</h2>,
            h3: value => <h3 className="manrope-bold text-lg">{value.children}</h3>,
            ul: value => <ul className="list-disc">{value.children}</ul>,
            ol: value => <ol className="list-decimal">{value.children}</ol>,
            li: value => <li className="my-4">{value.children}</li>
          }}
        >
          {template.details}
        </ReactMarkdown>
      </div>
    </div>
  )
}
